import axios from 'axios';
import Cookies from 'js-cookie';

const state = {
  activeProductions: []
};

const mutations = {
  SET_ACTIVE_PRODUCTIONS(state, productions) {
    state.activeProductions = productions;
  },
  REMOVE_PRODUCTION(state, productionId) {
    state.activeProductions = state.activeProductions.filter(p => p.id !== productionId);
  }
};

const actions = {
  async startProduction(_, productionData) {
    try {
      // Extract data from payload
      const { recipe, workerId, businessId, businessEquipmentId } = productionData;
      
      // Ensure we include the businessEquipmentId in the request payload
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/productions`,
        {
          recipe,
          worker: workerId,
          business: businessId,
          business_equipment: businessEquipmentId  // Make sure this field name matches what the API expects
        },
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      
      return response.data;
    } catch (error) {
      console.error('Error starting production:', error);
      throw error;
    }
  },

  async completeProduction(_, { productionId, inventoryId }) {
    try {
      console.log('Debug - Completing production:', { productionId, inventoryId }); // Debug log
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/productions/${productionId}/complete`,
        { data: { inventoryId } }, // Changed to match Strapi's expected format
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error completing production:', error);
      if (error.response) {
        console.error('Error details:', error.response.data); // Debug log
      }
      throw error;
    }
  },

  async fetchBusinessProductions({ commit }, businessId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/api/productions?filters[business]=${businessId}`,
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );
      commit('SET_ACTIVE_PRODUCTIONS', response.data.results);
      return response.data.results;
    } catch (error) {
      console.error('Error fetching productions:', error);
      throw error;
    }
  }
};

const getters = {
  activeProductions: state => state.activeProductions
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
